import {
  ENTITY_LEVEL,
  SIDE_NAV_BAR_OPTIONS,
} from '../../../../common/constants/integrationConstants/crmConstants';
import { findLocation } from '../../../../common/util/reducerUtils/CrmReducerUtils';
import {
  changeCrmConfigTab,
  changeHeaderButton,
  changeSideListItem,
  showUnSavedModal,
} from '../../../routines/integrations/crmRoutines';

const initialState = {
  entityTab: ENTITY_LEVEL.ORGANIZATION,
  sideNavBarTab: SIDE_NAV_BAR_OPTIONS.DEDUPLICATION,
  stepBuilderTab: 0,
  stepBuilderPipelineTab: 0,
  syncDirection: null,
  currentConfigType: SIDE_NAV_BAR_OPTIONS.DEDUPLICATION,
  showUnSavedModal: false,
  onlySideListNav: false,
};

const crmConfigNavigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case changeCrmConfigTab.TRIGGER: {
      const { entityTab, sideNavBarTab, stepBuilderTab } = action.payload;
      const {
        entityTab: recentEntityTab,
        sideNavBarTab: recentSideNavBar,
        stepBuilderTab: recentStepBuilderTab,
        syncDirection: recentSyncDirection,
      } = { ...state };

      const newLocation = findLocation(
        {
          recentEntityTab,
          recentSideNavBar,
          recentStepBuilderTab,
          recentSyncDirection,
        },
        { entityTab, sideNavBarTab, stepBuilderTab }
      );

      return {
        ...state,
        ...newLocation,
        showUnSavedModal: false,
      };
    }
    case showUnSavedModal.TRIGGER: {
      return {
        ...state,
        showUnSavedModal: action.payload,
      };
    }
    case changeHeaderButton.TRIGGER: {
      return {
        ...state,
        buttonId: action.payload,
        onlySideListNav: false,
      };
    }
    case changeSideListItem.TRIGGER: {
      return {
        ...state,
        sideListId: action.payload,
        onlySideListNav: true,
      };
    }
    default:
      return state;
  }
};

export default crmConfigNavigationReducer;
